import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext } from "react";
import useSignalRConnection from "./useSignalRConnection";
const SignalRContext = createContext(null);
export const SignalRProvider = ({ hub, children, }) => {
    const connection = useSignalRConnection(hub);
    return (_jsx(SignalRContext.Provider, { value: connection, children: children }));
};
export const useSignalR = () => useContext(SignalRContext);
